<div class="w-full flex flex-col gap-lg px-lg" [formGroup]="formGroup">
    <div class="flex gap-lg">
        <hlm-form-field class="grow" label="First Name" labelFor="firstName" [required]="true">
            <input id="firstName" qa="last-name" autocomplete="turnoff" maxlength="20" hlmInput type="text" formControlName="firstName" />
            <hlm-error>Please enter a valid first name</hlm-error>
        </hlm-form-field>
        <hlm-form-field class="grow" label="Last Name" labelFor="lastName" [required]="true">
            <input id="lastName" qa="last-name" autocomplete="turnoff" maxlength="20" hlmInput type="text" formControlName="lastName" />
            <hlm-error>Please enter a valid last name</hlm-error>
        </hlm-form-field>
    </div>
    <hlm-form-field label="Phone Number" labelFor="phoneNumber" class="w-full" [required]="true">
        <input
            id="phoneNumber"
            hlmInput
            type="tel"
            qa="phone-number"
            maxlength="30"
            autocomplete="turnoff"
            formControlName="phoneNumber"
            placeholder="(123) 456-7890"
        />
        <hlm-error>Please enter a valid phone number</hlm-error>
    </hlm-form-field>
    <hlm-checkbox id="enableTextNotifications" formControlName="enableTextNotifications" label="Text me appointment updates" />
    <hlm-checkbox id="enableTextMarketing" formControlName="enableTextMarketing" label="Text me promotional offers" />
    <span class="text-sm text-text-secondary">
        By checking these boxes and completing the booking, you agree to receive texts at your number{{
            businessName ? ' from ' + businessName : ''
        }}
        powered by DaySmart. Msg frequency may vary. Msg &amp; data rates may apply. Consent not required for purchase. Reply HELP for help,
        STOP to cancel.
    </span>
    <div class="flex gap-lg">
        <a href="https://www.daysmart.com/privacy-policy/" class="text-primary-dark underline" target="_blank">Privacy Policy</a>
        <a href="https://www.daysmart.com/terms/" class="text-primary-dark underline" target="_blank">Terms</a>
    </div>
    <hlm-form-field label="Email" labelFor="email" class="w-full" [required]="true">
        <input
            id="email"
            hlmInput
            type="email"
            maxlength="60"
            autocomplete="turnoff"
            qa="email"
            formControlName="email"
            placeholder="email@address.com"
        />
        <hlm-error>Please enter a valid email</hlm-error>
    </hlm-form-field>
    <hlm-form-field *ngIf="canShowPasswordField" label="Password" labelFor="password" class="w-full" [required]="true">
        <input id="password" hlmInput type="password" formControlName="password" />
        <hlm-hint>A password must contain a minimum of 8 characters and at least 1 special character</hlm-hint>
    </hlm-form-field>
    <hlm-checkbox id="enableEmailMarketing" formControlName="enableEmailMarketing" label="Email me updates and promotions" />
    <ng-content *ngIf="clientAddressFeatureEnabled && accountBookingShowAddressFields">
        <hlm-form-field label="Address Line 1" labelFor="address1" class="w-full" [required]="accountBookingRequireAddressFields">
            <input
                #searchInput
                id="address1"
                qa="address-line-1"
                hlmInput
                maxlength="60"
                autocomplete="on"
                type="text"
                formControlName="address1"
            />
            <hlm-error>Please enter a valid address</hlm-error>
        </hlm-form-field>
        <hlm-form-field label="Address Line 2" labelFor="address2" class="w-full">
            <input id="address2" hlmInput type="text" qa="address-line-2" maxlength="30" autocomplete="on" formControlName="address2" />
            <hlm-error>Please enter a valid address</hlm-error>
        </hlm-form-field>
        <hlm-form-field label="City" labelFor="city" class="w-full" [required]="accountBookingRequireAddressFields">
            <input id="city" hlmInput type="text" qa="city" formControlName="city" autocomplete="on" maxlength="30" />
            <hlm-error>Please enter a valid city</hlm-error>
        </hlm-form-field>
        <div class="flex gap-lg">
            <hlm-form-field class="grow" label="State" labelFor="state" [required]="accountBookingRequireAddressFields">
                <input id="state" hlmInput type="text" qa="state" formControlName="state" autocomplete="on" maxlength="30" />
                <hlm-error>Please enter a valid state</hlm-error>
            </hlm-form-field>
            <hlm-form-field class="grow" label="Zip Code" labelFor="zipCode" [required]="accountBookingRequireAddressFields">
                <input id="zipCode" hlmInput type="text" qa="zipCode" autocomplete="on" maxlength="20" formControlName="zipCode" />
                <hlm-error>Please enter a valid zip code</hlm-error>
            </hlm-form-field>
        </div>
    </ng-content>
</div>
